import React, { FC, Fragment, useState } from 'react';
import styled from 'styled-components';

import { TierPoints1_2_3_ScoreCard } from '../../match-entry/score-card/tier-points-123--score-card';
import { TierPoints6_6_6_ScoreCard } from '../../match-entry/score-card/tier-points-666-score-card';
import { TeamGameMatchTeamDisplay } from '../../../../database.schema';
import { MATCH_FORMATS } from '../../../app/constants';
import { StablefordScoreCard } from '../../match-entry/score-card/stableford-score-card';

const TeamWrapper = styled.div`
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #eae6e6;
  border: 1px solid lightgray;
  border-radius: 5px;
  width: 100%;
  padding: 0.25rem;
`;

const ResultWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const PlayerDisplay = styled.div<{ bgColor?: string | null }>`
  text-align: center;
  vertical-align: middle;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 1rem;
  margin: auto;
`;
const PlayerName = styled.div<{ teamIndex: number }>`
  background: ${(props) => (props.teamIndex === 0 ? 'dodgerblue' : 'crimson')};
  color: white;
  text-align: center;
  vertical-align: middle;
  padding: 0.25rem;
  min-width: 4rem;
  border: 1px solid black;
  border-radius: 0.2rem;
  margin-right: 0.25rem;
`;
const Result = styled.div`
  text-align: center;
  vertical-align: middle;
  padding: 0.25rem;
  margin: 1rem 0;
  font-size: 1.5rem;
  color: black;
`;

const TeamTitle = styled.div`
  margin-right: 0.5rem;
  font-size: 1.25rem;
`;

const ScoreCardButton = styled.button`
  border: none;
  background: transparent;
  margin-bottom: 0.25rem;
`;

export const Arrow = styled.i`
  display: inline-block;
  width: 10px;
  height: 10px;
  vertical-align: middle;
  margin: 0 0.25rem;
`;

export const ArrowUp = styled(Arrow)<{ color: string }>`
  border: solid black;
  border-width: 0 4px 4px 0;
  padding: 4px;
  transform: rotate(-135deg);
  margin-top: 0.5rem;
`;

export const ArrowDown = styled(Arrow)<{ color: string }>`
  border: solid black;
  border-width: 0 4px 4px 0;
  padding: 4px;
  transform: rotate(45deg);
  margin-top: 0.25rem;
`;

type Props = {
  team: TeamGameMatchTeamDisplay;
  teamIndex: number;
  startingHole: number;
  courseId: number;
  matchFormat: string;
};

export const TeamGameStablefordResult: FC<Props> = ({ team, teamIndex, startingHole, courseId, matchFormat }): JSX.Element => {
  const [showScoreCard, setShowScoreCard] = useState<boolean>(false);
  return (
    <Fragment>
      <TeamWrapper>
        <ResultWrapper>
          <TeamTitle>{teamIndex === 0 ? `First ${team.players.length} Ball` : `Second  ${team.players.length} Ball`}</TeamTitle>
        </ResultWrapper>
        <ResultWrapper>
          <PlayerDisplay data-testid="player">
            {team.players.map((player, index: number) => (
              <div key={`player-${index}`}>
                <PlayerName teamIndex={teamIndex}>{`${player.nickName}`}</PlayerName>
              </div>
            ))}
          </PlayerDisplay>
        </ResultWrapper>
        <ScoreCardButton
          data-testid={`show-scorecard-${teamIndex}`}
          onClick={() => {
            setShowScoreCard(!showScoreCard);
          }}
        >
          {showScoreCard ? <ArrowUp color={'blue'} /> : <ArrowDown color={'red'} />}
        </ScoreCardButton>
        {showScoreCard && <StablefordScoreCard startingHole={startingHole} players={team.players} courseId={courseId} />}
      </TeamWrapper>
    </Fragment>
  );
};
